import { useState, useEffect } from 'react';

export interface PathOption {
  pathId: string;
  name: string;
}

interface PathAutocompleteProps {
  paths: PathOption[];
  onSelect: (pathId: string) => void;
  selectedPathId?: string;
}

const PathAutocomplete = ({ paths, onSelect, selectedPathId }: PathAutocompleteProps) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<PathOption[]>([]);

  // Keep the input in sync when the selected path changes
  useEffect(() => {
    if (selectedPathId) {
      const selected = paths.find(p => p.pathId === selectedPathId);
      setQuery(selected ? selected.name : '');
    } else {
      setQuery('');
    }
  }, [selectedPathId, paths]);

  useEffect(() => {
    if (query.trim().length === 0) {
      setResults([]);
      return;
    }
    const lower = query.toLowerCase();
    setResults(paths.filter(p => p.name.toLowerCase().includes(lower)));
  }, [query, paths]);

  return (
    <div className="relative">
      <input
        type="text"
        value={query}
        onChange={e => setQuery(e.target.value)}
        placeholder="Select path"
        className="w-full border border-gray-300 rounded-md py-2 pl-3 pr-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
      />
      {results.length > 0 && (
        <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
          {results.map(p => (
            <button
              key={p.pathId}
              onClick={() => {
                onSelect(p.pathId);
                setQuery(p.name);
                setResults([]);
              }}
              className="w-full text-left px-4 py-2 hover:bg-gray-100"
            >
              {p.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PathAutocomplete;
